import { render } from "./PositionsBlock.vue?vue&type=template&id=8f12b77c&scoped=true"
import script from "./PositionsBlock.vue?vue&type=script&lang=js"
export * from "./PositionsBlock.vue?vue&type=script&lang=js"

import "./PositionsBlock.vue?vue&type=style&index=0&id=8f12b77c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f12b77c"]])

export default __exports__